import { themedUseStyletron } from '../../../theme/customTheme'
import {  OperatorPanelWrapperFullSize } from '../../components/Layout'
import { ISensorDigitalFault } from './types'
import { FormattedMessage } from 'react-intl';
import { Badge } from 'baseui/badge';
import { ObjectBooleanTimeline } from '../../../features/Charts/ObjectBooleanTimeline';
import { Block } from 'baseui/block';
import { LastXDaysLabel } from '../SensorDigital/LastXDaysLabel';
import { getTimeRangeFromTimespan } from '../../../utils/timeUtils';

export const OperatorPanel = (props: ISensorDigitalFault) => {
    const [, theme] = themedUseStyletron();
    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    return (
        <>
            <OperatorPanelWrapperFullSize
                objectId={props.id}
                resourceGroupId={props.resourceGroupId}
                statusContent={
                    <>

                        {!props.isErr && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.OK" defaultMessage="OK" />} />}
                    </>
                }            >
            </OperatorPanelWrapperFullSize>
            <Block marginTop={theme.sizing.scale800}></Block>
            <LastXDaysLabel days={7}></LastXDaysLabel>
            <ObjectBooleanTimeline currentValue={props.isErr} onColor={theme.colors.warning} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isErr'}></ObjectBooleanTimeline>
        </>

    )
} 